import React from "react";
import Box from "@mui/material/Box";
import followMePng from "src/assets/images/FollowMe.png"; // ✅ place your PNG in this folder

const DumperFollowMeIcon = ({ size = 55, ...props }) => (
  <Box
    component="img"
    src={followMePng}
    alt="Follow Me Icon"
    sx={{
      width: size,
      height: size,
      display: "inline-block"
    }}
    {...props}
  />
);

export default DumperFollowMeIcon;
